var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Floor = function () {
    function Floor() {
        _classCallCheck(this, Floor);
    }

    _createClass(Floor, null, [{
        key: 'select',
        value: function select(state, floorID) {
            state = state.setIn(['scene', 'selectedFloor'], floorID);

            return { updatedState: state };
        }
    }, {
        key: 'setProperties',
        value: function setProperties(state, floorID, elevation) {
            state = state.setIn(['scene', 'floors', floorID, 'elevation'], elevation);
            return { updatedState: state };
        }
    }]);

    return Floor;
}();

export { Floor as default };